import { call, put } from 'redux-saga/effects';
import * as announcementApi from '../../api/index';
import {
    getActiveAnnouncements,
    dismissAnnouncement,
} from '../actions/announcementActionsHelper';

export function* handleGetActiveAnnouncements() {
    try {
        const response = yield call(announcementApi.getActiveAnnouncements);
        yield put(getActiveAnnouncements.success(response.data));
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to fetch announcements';
        yield put(getActiveAnnouncements.failed(errorMessage));
    }
}

export function* handleDismissAnnouncement(action) {
    try {
        const { announcementId } = action.payload;
        yield call(announcementApi.dismissAnnouncement, announcementId);
        yield put(dismissAnnouncement.success(announcementId));
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to dismiss announcement';
        yield put(dismissAnnouncement.failed(errorMessage));
    }
}
